import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2021-12-29'
        tag='Mercari'
        title='Mercari Automation - Your Virtual Assistants To Fast Selling'
      >
        <p>
          Selling or reselling on a platform like Mercari may seem easy, but you have to be strategic if you want to
          sell quickly. While it is similar to eBay and Facebook Marketplace that sell a wide variety of items, Mercari
          focuses on the simplicity of shopping and selling, and of course, the convenience of both buyers and sellers.
          That is why the platform prioritizes ease from the app's interface and selling fees up to the overall user
          journey. How do they do it? Mercari allows automation tools to get the best out of their selling experience.{' '}
        </p>

        <h3>The trick to massive sales</h3>
        <p>
          Among the many helpful tips to selling a lot is to have your listings stay atop a user's feed. For instance,
          Poshmark has a niche audience that looks for high-end items like designer clothes. But with thousands of users
          selling similar designers in a week, it will be difficult for a seller to keep their luxury items at the top
          of the search results, no matter their visually-appealing photos and complete descriptions. This is why they
          use Poshmark automation bots that relist their items so the algorithm will consider them as "new lists."
        </p>
        <p>
          When a listing is read as "fresh" or "the latest," this will gain further exposure to thousands of users. In
          this way, more people would possibly inquire and make a purchase. The more visible an item is to a wider
          customer base, the more chances of a seller closing deals.
        </p>
        <p>
          It is important to note that Mercari is unlike other marketplaces that once you list something, you can forget
          about it. Mercari is similar to other social media platforms like Instagram, such that the more you post, the
          more you maintain a strong online presence and engaging content. In turn, more people follow you, recommend
          you to their friends, and buy from you.
        </p>

        <h3>Cross-listing saves time and gives exposure.</h3>
        <p>
          Beyond turning your listings "new," crossposting your items to other platforms works well to your advantage.
          With hundreds of marketplaces out there, you would want to gain further exposure to millions of other users.
          Now, you may be thinking this is a tedious task, an entire time-consuming process of posting your items on a
          marketplace then doing it all over again as many times as you need.
        </p>
        <p>
          This is where automation tools or auto listers come in. These apps or software helps you automatically copy
          listings from Poshmark to Mercari without logging in to the apps from time to time. Like the Poshmark
          automation, you can save time in crossposting with just a few clicks of a button.
        </p>
        <p>
          Once you run these tools, you are now free to do other daily tasks. You will only recheck the app or website
          if you want to track or study your earnings or when you receive notifications for any inquiry about an item, a
          refund, a shipping delay, or to settle a case of disputes.
        </p>

        <p>Here are some Mercari bots available in the market:</p>
        <h4>MercariBOT</h4>
        <p>
          MercariBOT acts like a virtual assistant that helps sellers boost active listings and gain additional
          exposure. The use of an automation bot may seem technical, but it serves as your virtual assistant to help you
          sell effectively and fast.
        </p>
        <p>
          If you are worried about using a "bot" on Mercari, you don't need to because existing software is not
          considered a scam or spam. Bots are ordinary tools that help sellers navigate the entire process of e-commerce
          conveniently. It helps you gain stronger exposure and online presence from relisting your items automatically
          to crossposting them on other platforms.
        </p>
        <p>
          As for the pricing plans and options, MercariBOT offers a three (3)-day FREE trial for each plan, so you know
          what to expect before deciding which to purchase fully. The free trial includes manual listing,
          auto-relisting, importing your listing, and your Poshmark listings. However, the free guide or support is for
          three (3) days only. For one (1) month of subscription, the MercariBOT fee is $14.99 and $69.99 for six (6)
          months.
        </p>

        <h4>List Perfectly</h4>
        <p>
          You may have heard of List Perfectly, an online app allowing you to crosspost your items to other
          marketplaces. For instance, if you are originally selling on eBay, you can instantly cross-list all your items
          to Mercari by tapping "Copy Listings" on the app. This saves you a lot of time (about two hours or more,
          depending on the number of your items).
        </p>
        <p>
          They charge $29 per month for a simple plan of crossposting include images, titles, and descriptions. However,
          it costs $49 per month for additional details such as keywords, tags, barcodes, retail prices, and bulk
          relisting and delisting. Lastly, the full automation costs $69 per month, including professional keywords,
          instant photo editing guides, and more.
        </p>

        <h4>Vendoo</h4>
        <p>
          Similar to List Perfectly, Vendoo is also a common software for online resellers. This automation service
          relists, crossposts, delists, customizes your catalog, and provides you with your sales analytics. For their
          base plan, they offer $8.99 or $0.36 per item. This monthly plan includes three marketplaces, an inventory
          page, sales & profit analytics, and image hosting.
        </p>

        <h3>OneShop</h3>
        <p>
          OneShop is a great all-in-one platform you can use that shares your listings up to 28,000 a week without you,
          as a seller, having to do anything. They have access to different marketplaces such as Poshmark and Mercari,
          so you can be assured that hundreds and thousands of more potential buyers come across the items you sell.
        </p>
        <p>
          Aside from sharing, they automatically delist your items across all other platforms once they have been sold.
          Similarly, they spontaneously relist items that have been posted for so long. This means these are "bumped up"
          again on people's feeds across other marketplaces as if they are "new" items.
        </p>
        <p>
          Another good feature is you can also keep track of your profits. Any seller would need to know how much they
          are earning and/or losing, especially in discount offers. You can view your analytics that includes details of
          your sales, comparing it with other fellow sellers, and of course, you have options to set goals as a seller.
        </p>
        <p>
          Using such bots is worth it if you want to sell effectively and fast while giving you more time to attend to
          other personal matters.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
